var cartEnroll = function(){ 
  this.item_quantity_class = "item-quantity";
  
  this.init = function(){
    this.unregisterEvents();
  	this.registerEvents();
  };
  
  this.registerEvents = function() {
    $( document ).on( "change", "."+this.item_quantity_class,  this, function(e){
      e.data.onQuantityChange( $(this) );      
    });
    
    $( document ).on( "change", "#training-247-group-check", function() {
      if( $(this).is(":checked") ) {
        $(this).parent().parent().find('input[type=text]').show();
        //$( "#training-247-group-title" ).show();
      } else {
        //$( "#training-247-group-title" ).hide();
        $(this).parent().parent().find('input[type=text]').hide();
      }
    });
        
    $( document ).on( "submit", "#cartform", this, function(e) {    
      var me = this,
      isOk = true;      
      $( "td.cg-vak-enroll-td" ).each(function() {        
        var innerOk = true;
      	$(this).find( "table.cg-vak-enroll-cart-table" ).each(function(){      
          
          if( /([^\s])/.test( $(this).find("input.cg-vak-enroll-first-name").val() ) == false ) {
            $("#training-247-cart-error-block").show();
            $(this).find("input.cg-vak-enroll-first-name").css( "border-color","red" ); 
            innerOk = false;
            return false;	      	
          } else {
            $(this).find("input.cg-vak-enroll-first-name").css( "border-color","#ccc" ); 
          }
          
          if( /([^\s])/.test( $(this).find("input.cg-vak-enroll-last-name").val() ) == false ) {
            $("#training-247-cart-error-block").show();
            $(this).find("input.cg-vak-enroll-last-name").css( "border-color","red" );   
            innerOk = false;
            return false;	      	
          } else {
             $(this).find("input.cg-vak-enroll-last-name").css( "border-color","#ccc" );      
          }
          
          if( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( $(this).find("input.cg-vak-enroll-email").val() ) == false ) {
            $("#training-247-cart-error-block").show();
            $(this).find("input.cg-vak-enroll-email").css( "border-color","red" );      
            innerOk = false;
            return false;	      	
          } else {
            $(this).find("input.cg-vak-enroll-email").css( "border-color","#ccc" ); 
          }
          
        });   
    
        if( !innerOk ) {
          isOk = innerOk;
          return false;
        }
      }); 
      
      if( $( "#training-247-group-check" ).is(":checked") ) {
        if( /([^\s])/.test( $( "#training-247-group-title" ).val() ) == false ) {
          $( "#training-247-group-title" ).css( "border-color","red" ); 
          return false; 
        } else {
          $( "#training-247-group-title" ).css( "border-color","#ccc" ); 
          $("#enroller-247-group-flag").val("YES");
          $("#enroller-247-group-name").val( $( "#training-247-group-title" ).val() );
        }
        
        if( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( $( "#training-247-group-delegate" ).val() ) == false ) {
          $( "#training-247-group-delegate" ).css( "border-color","red" ); 
          return false; 
        } else {
          $( "#training-247-group-delegate" ).css( "border-color","#ccc" ); 
          $("#enroller-247-group-flag").val("YES");
          $("#enroller-247-group-email").val( $( "#training-247-group-delegate" ).val() );
        }
      } else {
        $("#enroller-247-group-flag").val("NO");
      }
      
      return isOk;
    });
  };
  
  this.unregisterEvents = function(){
    
  };
  
  this.onQuantityChange = function( elem ){
  	var enrollTd = $( "td[item-id="+ elem.attr("item-id") +"]" ),
    currentTableCount = parseInt( enrollTd.find('table').length ),
    currentItemQuantity = parseInt( elem.val() ),
    tableStr = '';   
    
    if( currentItemQuantity > currentTableCount ) {
      var diff = currentItemQuantity - currentTableCount;
      for( var i = 0; i < diff; i++ ) {
        currentTableCount++;
        tableStr = '<table class="cg-vak-enroll-cart-table">';
        tableStr += '<tr>';
        tableStr += '<td>Enroll This Course For : </td>';
        tableStr += '<td>';
        tableStr += '<input type="text" class="cg-vak-enroll-first-name" name="attributes[Enroller-247-'+ elem.attr("item-id") +'-firstname-'+ currentTableCount +']" placeholder="First Name" />';
        tableStr += '</td>';
        tableStr += '<td>';
        tableStr += '<input type="text" class="cg-vak-enroll-last-name" name="attributes[Enroller-247-'+ elem.attr("item-id") +'-lastname-'+ currentTableCount +']" placeholder="Last Name" />';
        tableStr += '</td>';
        tableStr += '<td>';
        tableStr += '<input type="text" class="cg-vak-enroll-email" name="attributes[Enroller-247-'+ elem.attr("item-id") +'-email-'+ currentTableCount +']" placeholder="Email" />';
        tableStr += '</td>';
        tableStr += '</tr>';
        tableStr += '</table>';
        enrollTd.append( tableStr );        
      }
    } else if( elem.val() < enrollTd.children().length ) {
      enrollTd.find("table").slice( currentItemQuantity, currentTableCount ).remove()
    }
  };
    
};